module.exports = __webpack_public_path__ + "img/progress_054.94094558.png";